// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2ueWu","imageUploader":"EGiftCard_imageUploader__3JcDv"};